export const formatCurrency = (price, locale) => {
    return price
        ? new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
        }).format(price)
        : '-';
};
